// entry-careerで使用を想定
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';

type MailAddress = {
  emailAddress: string;
};
type PasswordEditInfo = {
  password: string;
  newPassword: string;
};

// メールアドレス
export const getMailAddress = async (): Promise<MailAddress> => {
  const res = await axios.get(endpoint.mailAddress);
  return res.data;
};
// パスワード変更
export const postPasswordEdit = async (params: PasswordEditInfo) => {
  const res = await axios.post(endpoint.passwordEdit, params);
  return res;
};
